import { ReactNode } from "react";

interface TranslationStrings {
    // DonoTrain Ready
    DONO_TRAIN_IS_READY: ReactNode;

    // DonoTrain Primed
    DONO_TRAIN_IS_PRIMED: ReactNode;
    DONO_TRAIN_START_CONDITION: ReactNode;

    // DonoTrain InProgress
    DONO_TRAIN_AMOUNT_UNTIL_NEXT_LEVEL: ReactNode;
}

interface Translations {
    de: TranslationStrings;
    en: TranslationStrings;
}

export const translations: Translations = {
    de: {
        DONO_TRAIN_IS_READY: <span style={{ marginLeft: "5px" }}>Hype Train ist <span className="dono-train-ready-text">READY</span>!</span>,
        DONO_TRAIN_IS_PRIMED: <span style={{ marginLeft: "5px" }}>Hype Train<br/><span className="dono-train-approaching-text">kommt</span> !</span>,
        DONO_TRAIN_START_CONDITION: "Noch 1 weitere Donation bis zum Start!",
        DONO_TRAIN_AMOUNT_UNTIL_NEXT_LEVEL: "bis zum nächsten Level",
    },
    en: {
        DONO_TRAIN_IS_READY: <span style={{ marginLeft: "5px" }}>Hype Train is <span className="dono-train-ready-text">READY</span>!</span>,
        DONO_TRAIN_IS_PRIMED: <span style={{ marginLeft: "5px" }}>Hype Train<br/><span className="dono-train-approaching-text">is approaching</span> !</span>,
        DONO_TRAIN_START_CONDITION: "Just 1 more Donation to start!",
        DONO_TRAIN_AMOUNT_UNTIL_NEXT_LEVEL: "until next Level",
    }
}

export const translate = <T extends keyof TranslationStrings>(prop: T): TranslationStrings[T] => {
    const language = import.meta.env.VITE_LANGUAGE as keyof Translations;
    return translations[language][prop];
}

type InlineTranslation = {
    [language in keyof Translations]: ReactNode;
};
export const inlineTranslate = (data: InlineTranslation) => {
    const language = import.meta.env.VITE_LANGUAGE as keyof Translations;

    return data[language]
}